import { helpers } from "../../common/lib";
import getInitialState from "../get-initial-state";
import { actionTypes } from "./actions";

export default function (state = getInitialState.list(), action) {
    switch (action.type) {
        case actionTypes.AUDIT_ITEM_CLEAR: {
            return { ...state, item: null };
        }
        case actionTypes.AUDIT_ITEM_SET: {
            const { audit } = action.payload;
            return { ...state, item: audit };
        }
        case actionTypes.AUDITS_LIST_CLEAR:
        case actionTypes.AUDITS_LIST_GET_REQUEST: {
            return getInitialState.list();
        }
        case actionTypes.AUDITS_LIST_GET_SUCCESS: {
            const { audits } = action.payload;
            return helpers.getListReducer(state, audits.results);
        }
        case actionTypes.AUDIT_CLOSE_SUCCESS: {
            const { audit } = action.payload;
            return helpers.mergeListReducer(state, [audit]);
        }
        case actionTypes.AUDIT_PATCH_SUCCESS: {
            const { audit } = action.payload;
            return helpers.getListItemReducer(state, audit);
        }
        case actionTypes.AUDITS_LIST_POST_SUCCESS: {
            const { audits } = action.payload;
            return helpers.mergeListReducer(state, audits);
        }
        case actionTypes.AUDITS_LIST_SET: {
            const { audits } = action.payload;
            return { ...state, data: audits };
        }
        default: {
            return state;
        }
    }
}
